import { Box, Link, Text } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
interface SnackBarAlertsProps {
  showSnackBar: boolean
  alertType: 'info' | 'warning' | 'critical' | 'positive'
  alertMessage: string
  toggleAlert: () => void
  onClickLink: () => void
}

const SnackBarAlerts = ({
  alertType,
  alertMessage,
  toggleAlert,
  onClickLink,
  showSnackBar,
}: SnackBarAlertsProps) => {
  if (showSnackBar) {
    return (
      <Box width="full" padding="s24" position="absolute" className={'Common_floatingAlert'}>
        <Callout
          compact
          type={alertType}
          onRemove={toggleAlert}
          link={
            <Link.Touchable type="solid" onClick={onClickLink}>
              {i18n.t('common.view')}
            </Link.Touchable>
          }
        >
          <Box>
            <Text.Normal>{alertMessage}</Text.Normal>
          </Box>
        </Callout>
      </Box>
    )
  }
}

export default SnackBarAlerts
